import { Nullable } from '../lib/utils/utilsTypes'

export type TProductVideo =
	| string
	| {
			SRC?: string | null
			POSTER?: string | null
	  }

export type TProduct = {
	ID?: number
	TITLE?: string
	PRICE: TPrice
	OLD_PRICE?: TPrice
	KOD?: TProductCode
	SECTION_ID?: number
	SECTION_CODE?: string
	SECTION_NAME?: string
	IMAGE?: string
	IMAGES?: string[]
	RELATED_COLORS?: TColor[]
	RELATED_PRODUCTS?: number
	PREVIEW_TEXT?: string
	ARTICLE?: string
	NOMENCLATURE?: string
	DESCRIPTION?: string
	PROPERTIES?: TSpecs
	ACCESSORIES?: TAccessories
	BONUS_CHARGE?: number
	BONUS_PAY?: number
	SEO?: TSeo
	SERVICES?: TServicesServer
	YOUTUBE_VIDEO?: string[]
	VIDEO?: TProductVideo[] | null
	INSTALLMENT_PROGRAMS?: string[]
	LINK?: string
	STORES?: TShop[]
	ORDER_TYPE?: OrderType
	CONTROL?: ProductControl[] | null
	HIDE_PRICE?: boolean
	PROMOTION?: TPromotion[]
	SELECTED_PROPS?: TSelectedProductProps[]
	DELIVERY_DATE?: string
	DELIVERY_DATE_IN_CITY?: string
	DEFAULT_DELIVERY_PRICE?: number
	VISIBLE_PRICE?: boolean
	STOCK_ID?: string
	PART_NUMBER?: string
	SHORT_INFO?: string
	AMOUNT_LIMIT?: number
	WARRANTY?: string
	IS_ARCHIVE?: boolean
	HAS_ACCESSORIES?: boolean
	HAS_SERVICES?: boolean
	REVIEWS_SUMMARY?: TProductReviewsSummary | null
	PAYMENTS?: TPaymentGroups
	IMAGES_RESIZE?: string[]
	BUTTON_NAME?: string
	IS_NEW?: ['Да'] | ['Нет'] | [] | undefined | 'Да' | 'Нет'
	SHOP_DELIVERY_DATE?: string
	SECTIONS: string[]
	INFO?: {
		ID: number
		TITLE: string
		IMAGES: string[]
		GALLERY: string[]
		PRICE: number
		COLOR_BUTTON?: string
		TEXT_BUTTON: string
		TEXT_UNDEX_BUTTON?: string
	}
	DELIVERY?: {
		PICKUP: { DATE: string; SHOPS_COUNT: number }
		HOME: { DATE: string; TODAY_PRICE: string; PRICE: number }
		PVZ: boolean
	}
}

export type TPrice = {
	VALUE: number
	PRICE_TYPE?: string
}

export type TProductReviewsSummary = {
	RATING: number
	COUNT: number
}

export type TProductCode = string

export type TColor = {
	COLOR: {
		NAME: string
		CODE: string | null
	}
	KOD: string
	PICTURE: string | 0
	IS_CURRENT: boolean
}

export type TSpecs = Record<string, TSpecGroup>

export type TSpecGroup = {
	GROUP_NAME: string
	GROUP_SORT?: string
	HIDE_COMPARE?: boolean
	GROUP_PROPERTIES: Record<string, TSpecItem>
}

export type TSpecItem = {
	name: string
	value?: string
	values: {
		NAME: string
		LINK?: string
	}[]
	link?: string
}

export type TAccessories = Record<string, TAccessoryGroup>

export type TAccessoryGroup = {
	ACCESSORIES?: TAccessory[]
	SECTION_ID: number
	SECTION_NAME: string
	SECTION_SORT?: number
}

export type TAccessory = {
	PRICES?: {
		PRICE: TPrice
		OLD_PRICE?: TPrice
	}
	ID: number
	IMAGE: string
	IMAGES?: string[]
	IMAGES_RESIZE?: string[]
	KOD: number
	PROMOTION?: TPromotion[]
	REVIEWS_SUMMARY?: TProductReviewsSummary | null
	TITLE: string
}

export type TSeo = {
	ELEMENT_DETAIL_PICTURE_FILE_ALT?: string
	ELEMENT_META_DESCRIPTION?: string
	ELEMENT_META_TITLE?: string
	ELEMENT_PAGE_TITLE?: string
	ELEMENT_PREVIEW_PICTURE_FILE_ALT?: string
	SECTION_DETAIL_PICTURE_FILE_ALT?: string
	SECTION_META_DESCRIPTION?: string
	SECTION_META_KEYWORDS?: string
	SECTION_META_TITLE?: string
	SECTION_PAGE_TITLE?: string
	SECTION_PICTURE_FILE_ALT?: string
	DESCRIPTION?: string
}

export type TServicesServer = Record<string, TServiceServer>

export type TShop = {
	ID?: string | null
	STORE_ID?: string | null
	NAME: string | null
	FULL_ADDRESS: string | null
	TEXT_DESCRIPTION?: string | null
	PHONE: string | null
	MALL: string | null
	METRO: string | null
	METRO_LINE: string | null
	AMOUNT?: string | null
	REGION: string | null
	IMAGES: string[] | null
	SCHEDULE: string | null
	GPS_N: string | null
	GPS_S: string | null
	TEXT_INFO?: string | null
	UF_IS_SERVICE?: `1` | `0`
	UF_IS_SHOP?: `1` | `0`
	DELIVERY_DATE?: string
	XML_ID?: string
	SCHEME_IMAGE?: string
}

export type TServiceServer = {
	TYPE: string
	ITEMS: {
		ID: number
		PRICE: number
		NAME: string
		TEXT: string
		PIC: string | false | null
		KOD: string
		SECTION_ID: number
	}[]
}

export enum OrderType {
	Order = 'ORDER',
	PreOrder = 'PREORDER',
	HideBuy = 'HIDE_BUY',
	Prereservation = 'PRERESERVATION',
	Reservation = 'RESERVATION',
	B2bDiscount = 'B2BDISCOUNT',
	Special = 'SPECIAL_PRICES',
	Archive = 'ARCHIVE',
	TCP = 'TCP'
}

export enum ProductControl {
	HidePrice = 'HidePrice',
	HideBuy = 'HideBay',
	Preorder = 'Preorder'
}

export type TPromotion = {
	CODE: string
	ID: number
	NAME: string
	PREVIEW_TEXT: string
	SHORT_NAME: Nullable<string>
	SORT: number
	BACKGROUND_COLOR: Nullable<string>
	TEXT_COLOR: Nullable<string>
	CUSTOM_LINK: Nullable<string>
	HIDE_ON_LIST?: boolean
	ACTIVE_TO: string
}

export type TSelectedProductProps = {
	name: string
	value: string
}

export type TPaymentGroups = Record<PayTypeNames, TPayment[]>

export enum PayTypeNames {
	Online = 'ONLINE',
	OnReceipt = 'ON_RECEIPT',
	Credit = 'CREDIT',
	Instalments = 'INSTALLMENT',
	Split = 'SPLIT'
}

export type TPayment = {
	ID: string
	PAY_SYSTEM_ID?: string
	NAME: string
	PSA_NAME?: string
	CODE?: string | undefined
	ACTION_FILE?: string
	DESCRIPTION?: string
	LOGOTIP?: string
}
